import {DropdownVATOptions, mapVATCategoryToDropdownVAT} from "../../../../../../types/enums.ts";
import {InvoiceLineItem} from "../../CreateInvoicePage/types.ts";
import {RecurringSeriesDetails, RecurringSeriesLineDetails} from "../types/recurringInvoice.ts";
import {addDaysToIsoDate} from "./recurringInvoiceFormat.ts";
import type {Unit, VATCategory} from '../../../../../../generated/enums.ts';

function toDropdownVat(line: RecurringSeriesLineDetails): DropdownVATOptions {
    return mapVATCategoryToDropdownVAT(
        line.vat_category as VATCategory,
        line.vat_rate_percentage / 100,
    )
}

export function seriesLinesToPreviewLines(series: RecurringSeriesDetails): InvoiceLineItem[] {
    return series.lines.map((line) => ({
        id: line.id,
        description: line.description,
        quantity: Number(line.quantity),
        unit: line.unit as Unit,
        unitPrice: line.unit_price_net_cents / 100,
        vat: toDropdownVat(line),
        catalogueItemId: line.catalogue_item_id,
        saveToCatalogue: false,
    }))
}

export type NextInvoiceChange = {
    label: string
    value: string
    reason: string
}

export function nextInvoiceChanges(series: RecurringSeriesDetails): NextInvoiceChange[] {
    return [
        {
            label: 'Factuurdatum',
            value: series.next_run_on,
            reason: series.last_run_on
                ? `Vorige factuur was op ${series.last_run_on}`
                : 'Dit wordt de eerste factuur van deze reeks',
        },
        {
            label: 'Vervaldatum',
            value: addDaysToIsoDate(series.next_run_on, series.payment_term),
            reason: `${series.payment_term} dagen na de factuurdatum`,
        },
        {
            label: 'Factuurnummer',
            value: '',
            reason: 'Wordt toegekend zodra de factuur definitief wordt gemaakt',
        },
    ]
}
